export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";

export const FETCH_CHART_DATA_REQUEST = "FETCH_CHART_DATA_REQUEST";
export const FETCH_CHART_DATA_SUCCESS = "FETCH_CHART_DATA_SUCCESS";
export const FETCH_CHART_DATA_FAILURE = "FETCH_CHART_DATA_FAILURE";
